import { ExpertRequestStage } from '@/__generated__/graphql';

/**
 * Shared ER lifecycle-stage presentation tokens (ENG-5290 T2). Every stage
 * surface — badge, stage dropdown, banners — reads from this one set so colors
 * never drift. The class strings are literal (not interpolated) so Tailwind JIT
 * emits the arbitrary-value utilities; the underlying --erStage* CSS vars
 * (theme/index.css) flip for light/dark via the cascade.
 */
export const ER_STAGE_LABEL: Record<ExpertRequestStage, string> = {
  [ExpertRequestStage.Draft]: 'Draft',
  [ExpertRequestStage.Active]: 'Active',
  [ExpertRequestStage.OnHold]: 'On hold',
  [ExpertRequestStage.Closed]: 'Closed',
};

/** Pill fill: background + text (borderless — one tint fill, ENG-5314). */
export const ER_STAGE_PILL: Record<ExpertRequestStage, string> = {
  [ExpertRequestStage.Draft]: 'bg-[var(--erStageDraftBg)] text-[var(--erStageDraftFg)]',
  [ExpertRequestStage.Active]: 'bg-[var(--erStageActiveBg)] text-[var(--erStageActiveFg)]',
  [ExpertRequestStage.OnHold]: 'bg-[var(--erStageOnholdBg)] text-[var(--erStageOnholdFg)]',
  [ExpertRequestStage.Closed]: 'bg-[var(--erStageClosedBg)] text-[var(--erStageClosedFg)]',
};

/** Leading status dot fill. */
export const ER_STAGE_DOT: Record<ExpertRequestStage, string> = {
  [ExpertRequestStage.Draft]: 'bg-[var(--erStageDraftDot)]',
  [ExpertRequestStage.Active]: 'bg-[var(--erStageActiveDot)]',
  [ExpertRequestStage.OnHold]: 'bg-[var(--erStageOnholdDot)]',
  [ExpertRequestStage.Closed]: 'bg-[var(--erStageClosedDot)]',
};
